export default __webpack_public_path__ + "static/media/fakturering.5369d8ef.pdf";